
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fb",
      function () {
        return require("private-next-pages/fb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fb"])
      });
    }
  